<div class="modal-content">
    <div class="modal-header justify-content-center">
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
            <i class="nc-icon nc-simple-remove"></i>
        </button>
        <h5 class="title title-up">{{ title }}</h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="card card-plain">
                <div class="card-header" role="tab" id="headingOne">
                    <span data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Informe as informações abaixo para criar o tipo de bens
                    </span>
                </div>
                <div class="card-body">
                    <form [formGroup]="form">
                        <div class="row justify-content-center">
                            <!-- <div class="col-md-4">
                                <label for="">Número do Tipo do bem</label>
                                <div class="form-group">
                                    <input type="number" class="form-control" placeholder="Tipo" formControlName="nR_BPM_TIPO_BEM_PATRIMONIAL" [ngClass]="{
                                        'is-invalid':
                                          form.controls.nR_BPM_TIPO_BEM_PATRIMONIAL.errors?.required &&
                                          form.controls.nR_BPM_TIPO_BEM_PATRIMONIAL.touched
                                      }" required>
                                </div>

                            </div> -->
                            <div class="col-md-4">
                                <label for="">Classe</label>
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Classe" formControlName="cD_BPM_CLASSE_TIPO_BEM" [ngClass]="{
                                        'is-invalid':
                                          form.controls.cD_BPM_CLASSE_TIPO_BEM.errors?.required &&
                                          form.controls.cD_BPM_CLASSE_TIPO_BEM.touched
                                      }" required>
                                </div>

                            </div>
                            <div class="col-md-4">
                                <label for="">TUC</label>
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="TUC" formControlName="cD_BPM_TUC_TIPO_BEM" [ngClass]="{
                                        'is-invalid':
                                          form.controls.cD_BPM_TUC_TIPO_BEM.errors?.required &&
                                          form.controls.cD_BPM_TUC_TIPO_BEM.touched
                                      }" required>
                                </div>

                            </div>
                            <div class="col-md-4">
                                <label for="">AT1</label>
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="AT1" formControlName="cD_BPM_AT1_TIPO_BEM" [ngClass]="{
                                        'is-invalid':
                                          form.controls.cD_BPM_AT1_TIPO_BEM.errors?.required &&
                                          form.controls.cD_BPM_AT1_TIPO_BEM.touched
                                      }" required>
                                </div>

                            </div>
                            <div class="col-md-4">
                                <label for="">Tipo de Bem</label>
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Tipo de bens" formControlName="dS_BPM_DESCRICAO_TIPO_BEM"
                                    [ngClass]="{
                                        'is-invalid':
                                          form.controls.dS_BPM_DESCRICAO_TIPO_BEM.errors?.required &&
                                          form.controls.dS_BPM_DESCRICAO_TIPO_BEM.touched
                                      }" required>
                                </div>

                            </div>
                            <div class="col-md-4 mx-auto">
                                <div class="form-group">
                                    <label for="depreciacao">Depreciação</label>
                                    <input type="text" class="form-control text-left" currencyMask
                                        formControlName="vL_BPM_ALIQUOTA_DEPRECIACAO" id="depreciacao"
                                        placeholder="Depreciação"
                                        [options]="{ prefix: '',suffix:' %'}"
                                        [ngClass]="{
                                            'is-invalid':
                                              form.controls.vL_BPM_ALIQUOTA_DEPRECIACAO.errors?.required &&
                                              form.controls.vL_BPM_ALIQUOTA_DEPRECIACAO.touched
                                          }" required>
                                </div>
                            </div>

                            <!-- <div class="col-md-4">
                                <label for="">Denominação</label>
                                <div class="form-group">
                                    <input type="text" class="form-control text-center" placeholder="Informe o tipo de bens" formControlName="dS_BPM_TIPO_BEM_PATRIMONIAL" [ngClass]="{
                                        'is-invalid':
                                          form.controls.dS_BPM_TIPO_BEM_PATRIMONIAL.errors?.required &&
                                          form.controls.dS_BPM_TIPO_BEM_PATRIMONIAL.touched
                                      }" required>
                                </div>

                            </div> -->
                            <div class="col-md-4">
                                <label for="">Denominação Classe</label>
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Denominação Classe" formControlName="dS_BPM_DENOMINACAO_CLASSE_TIPO_BEM" [ngClass]="{
                                        'is-invalid':
                                          form.controls.dS_BPM_DENOMINACAO_CLASSE_TIPO_BEM.errors?.required &&
                                          form.controls.dS_BPM_DENOMINACAO_CLASSE_TIPO_BEM.touched
                                      }" required>
                                </div>

                            </div>
                            <div class="col-md-4 ">
                                <label>Ativo</label>
                                <div class="form-group">
                                    <select formControlName="fL_BPM_ATIVO" class="form-control custom-select text-center" aria-label="Small">
                                        <option selected disabled>Ativo</option>
                                        <option value="1">Sim</option>
                                        <option value="0">Não</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="row">
                        <div class="col-md-12 text-center" *ngIf="loading">
                            <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!loading" class="modal-footer">
        <div class="left-side">
            <button type="button" class="btn btn-danger btn-link" (click)="activeModal.close()">
                Cancelar
            </button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
            <button type="button" [disabled]="!form.valid"  class="btn btn-success btn-link" (click)="submit()">
                Salvar
            </button>
        </div>
    </div>
</div>